import { render, staticRenderFns } from "./Traslados.vue?vue&type=template&id=8e98c4ee&scoped=true"
import script from "./Traslados.vue?vue&type=script&lang=js"
export * from "./Traslados.vue?vue&type=script&lang=js"
import style0 from "./Traslados.vue?vue&type=style&index=0&id=8e98c4ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e98c4ee",
  null
  
)

export default component.exports